module.exports = __webpack_public_path__ + "components/guide-page/static/icon-avatar-1e4f673646bf573901ef66e06d0f2713.svg";